import { spawn } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

import {
  channelsGetAllSaga,
  channelsGetOneSaga,
  broadcastSettingsSaga,
  channelDeleteOneSaga,
  channelCreateOneSaga,
  channelEditOneSaga,
} from "./channels";

import {
  studioToken,
  editorAuth,
  editorAuthRemove,
  editorAuthPassword,
  editorAuthPublicPrivate,
} from "./auth";

import {
  viewerChannelsGetOneSaga,
  viewerBroadcastSettingsSaga,
  viewerStreamState,
  viewerPlaybackUrlSaga,
  viewerStreamCount,
  viewerVerifyPassword,
  viewerRefreshToken,
  viewerAuth,
  reactToStream,
  removeErrorMessage,
} from "./viewer";

export default function* rootSaga(): SagaIterator {
  yield spawn(channelsGetAllSaga);
  yield spawn(channelsGetOneSaga);
  yield spawn(broadcastSettingsSaga);
  yield spawn(channelDeleteOneSaga);
  yield spawn(channelCreateOneSaga);
  yield spawn(channelEditOneSaga);
  yield spawn(studioToken);
  yield spawn(editorAuth);
  yield spawn(editorAuthRemove);
  yield spawn(editorAuthPassword);
  yield spawn(editorAuthPublicPrivate);
  yield spawn(viewerChannelsGetOneSaga);
  yield spawn(viewerBroadcastSettingsSaga);
  yield spawn(viewerPlaybackUrlSaga);
  yield spawn(viewerStreamState);
  yield spawn(viewerStreamCount);
  yield spawn(viewerVerifyPassword);
  yield spawn(viewerRefreshToken);
  yield spawn(viewerAuth);
  yield spawn(reactToStream);
  yield spawn(removeErrorMessage);
}
